module.exports = __webpack_public_path__ + "media/images/flags/4x3/bwa-9609a72fa2c128c0300f555247874f36.svg";